module.exports = __webpack_public_path__ + "empty_state_millenials_at_festival-5e4b9f2e6947d9d955c1be0d4437461f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/empty_state_millenials_at_festival.png
// module id = 1756
// module chunks = 1